import { SelectHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...rest }, ref) => (
    <select ref={ref} className={clsx('w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary', className)} {...rest}>
      {children}
    </select>
  ),
);
Select.displayName = 'Select';
